import { I } from "@angular/cdk/keycodes";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-edit-gps-type",
  templateUrl: "./admin-edit-gps-type.component.html",
  styleUrls: ["./admin-edit-gps-type.component.css"],
})
export class AdminEditGpsTypeComponent implements OnInit {
  editgpsTypeForm: FormGroup;
  token: any;
  loading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matdialogref: MatDialogRef<AdminEditGpsTypeComponent>,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.editgpsTypeForm = this.formBuilder.group({
      server_name: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      server_url: ["", Validators.compose([Validators.required])],
      server_token: ["", Validators.compose([Validators.required])],
    });
    if (this.data.item) {
      this.editgpsTypeForm.patchValue(this.data.item);
    }
  }
  public get GpsTypeFormControl() {
    return this.editgpsTypeForm.controls;
  }
  close() {
    this.matdialogref.close();
  }
  UpdateGps() {
    if (this.editgpsTypeForm.valid) {
      this.loading = true;
      const updateGpsObj = {
        server_name: this.editgpsTypeForm.value.server_name,
        server_url: this.editgpsTypeForm.value.server_url,
        server_token: this.editgpsTypeForm.value.server_token,
      };
      this.services
        .UpdateGPSType(updateGpsObj, this.token, this.data.item._id)
        .subscribe(
          (response: any) => {
            if (response.status === 200) {
              this.matdialogref.close();
            }
          },
          (error) => {
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "invalid signature") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        );
    }
  }
}
